document.addEventListener("DOMContentLoaded", function (event) {
  $('.scroll-to-bottom').click(function() {
    $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
  });
  var InterValObj, SysSecond;
  function SetRemainTime() {
    var bf_time_now = new Date();
    bf_time_now = bf_time_now.getTime();
    var bf_time_distance = bf_time_end - bf_time_now;
    var bf_int_day, bf_int_hour, bf_int_minute, bf_int_second;
    if (bf_time_distance <= 0) {
      $("#countdown_box .day").html("00");
      $("#countdown_box .hour").html("00");
      $("#countdown_box .minite").html("00");
      $("#countdown_box .second").html("00");
      clearInterval(InterValObj);
      return;
    }
    bf_int_day = Math.floor(bf_time_distance / 86400000);
    bf_time_distance -= bf_int_day * 86400000;

    bf_int_hour = Math.floor(bf_time_distance / 3600000);
    bf_time_distance -= bf_int_hour * 3600000;

    bf_int_minute = Math.floor(bf_time_distance / 60000);
    bf_time_distance -= bf_int_minute * 60000;

    bf_int_second = Math.floor(bf_time_distance / 1000);
    if (bf_int_day < 10) bf_int_day = "0" + bf_int_day;
    if (bf_int_hour < 10) bf_int_hour = "0" + bf_int_hour;

    if (bf_int_minute < 10) bf_int_minute = "0" + bf_int_minute;

    if (bf_int_second < 10) bf_int_second = "0" + bf_int_second;
    $("#countdown_box .day").html(bf_int_day);
    $("#countdown_box .hour").html(bf_int_hour);
    $("#countdown_box .minite").html(bf_int_minute);
    $("#countdown_box .second").html(bf_int_second);
  }
  SysSecond = $("#countdown_box").data("countdown") || "";

  var bf_time_end = new Date(SysSecond);
  bf_time_end = bf_time_end.getTime();

  InterValObj = setInterval(function () {
    SetRemainTime();
  }, 1000);
});
